import { DIALOG_DATA, DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject, ViewChild, inject, signal } from '@angular/core';
import { DialogDirective } from '../dialog.directive';
import { DialogProps, DialogService } from '../dialog.service';
import { Icon } from '@client';
import { SLIDE_X } from '../../../animations/slide.animation';
@Component({
  selector: 'app-side-dialog',
  standalone: true,
  imports: [CommonModule, DialogDirective, DialogModule, Icon],
  templateUrl: './side-dialog.component.html',
  animations: [SLIDE_X],
})
export class SideDialogComponent {
  @ViewChild(DialogDirective, { static: true }) dialogDirective:
    | DialogDirective
    | undefined;

  hasBackdrop = signal<boolean>(true);
  width = signal<string>('w-full max-w-[520px]');

  dialogService = inject(DialogService);

  constructor(@Inject(DIALOG_DATA) private data: DialogProps) {}

  ngOnInit() {
    if (this.dialogDirective) {
      const viewContainerRef = this.dialogDirective.viewContainerRef;
      const componentRef = viewContainerRef.createComponent(
        this.data.component,
      );

      // 컴포넌트에 클래스 추가
      const hostElement = (componentRef.hostView as any)
        .rootNodes[0] as HTMLElement;
      hostElement.classList.add('flex-1');

      if (this.data.componentProps) {
        Object.entries(this.data.componentProps).map(([key, value]) => {
          componentRef.setInput(key, value);
        });
      }
    }

    if (this.data.width) {
      this.width.set(this.data.width);
    }

    if (this.data.hasBackdrop === false) {
      this.hasBackdrop.set(false);
    }
  }

  dismiss() {
    this.dialogService.sideDismiss();
  }
}
